// ========== Imports ==========
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'react-qr-code';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';
import { formatDate } from 'helpers/StringNumberFunction/formatDate';
import { moneyFunction } from 'helpers/StringNumberFunction/moneyFunction';

const generateQRCodeSVG = value => {
  const qrCodeElement = (
    <QRCode
      size={128}
      style={{ height: '75px', width: '75px' }}
      value={value}
      // viewBox={`0 0 128 128`}
    />
  );
  return renderToStaticMarkup(qrCodeElement);
};

// ========== Component ==========
export const ELetterServiceSubcon = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
  approvalLog,
}) => {
  let APInvoice;

  // ========== Get Company Details from local storage ==========
  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));

  let approverNameL1 = '';
  let approvalDateL1 = '';
  let roleNameL1 = '';
  let approverNameL2 = '';
  let approvalDateL2 = '';
  let roleNameL2 = '';
  let approverNameL3 = '';
  let approvalDateL3 = '';
  let roleNameL3 = '';
  let approverNameL4 = '';
  let approvalDateL4 = '';
  let roleNameL4 = '';
  let approverNameL5 = '';
  let approvalDateL5 = '';
  let roleNameL5 = '';

  if (approvalLog && approvalLog.length > 0) {
    const completedWorkflow = approvalLog.find(
      wf => wf.workFlowStatus === 'COMPLETED',
    );

    if (completedWorkflow?.workflowStep) {
      // Filter only approved steps and sort by stepNo
      const approvedSteps = completedWorkflow.workflowStep
        .filter(step => step.approvalStatus === 'APPROVED')
        .sort((a, b) => a.stepNo - b.stepNo);

      approvedSteps.forEach(step => {
        if (step.stepNo === 1) {
          approverNameL1 = step.name || '';
          approvalDateL1 = step.approvalDT ? formatDate(step.approvalDT) : '';
          roleNameL1 = step.roleName || '';
        } else if (step.stepNo === 2) {
          approverNameL2 = step.name || '';
          approvalDateL2 = step.approvalDT ? formatDate(step.approvalDT) : '';
          roleNameL2 = step.roleName || '';
        } else if (step.stepNo === 3) {
          approverNameL3 = step.name || '';
          approvalDateL3 = step.approvalDT ? formatDate(step.approvalDT) : '';
          roleNameL3 = step.roleName || '';
        } else if (step.stepNo === 4) {
          approverNameL4 = step.name || '';
          approvalDateL4 = step.approvalDT ? formatDate(step.approvalDT) : '';
          roleNameL4 = step.roleName || '';
        } else if (step.stepNo === 5) {
          approverNameL5 = step.name || '';
          approvalDateL5 = step.approvalDT ? formatDate(step.approvalDT) : '';
          roleNameL5 = step.roleName || '';
        }
      });
    }
  }

  const bankAddress = previewDetail?.bankAccount?.bankProfile?.address;

  console.log(previewDetail, 'previewDetail');

  // ========== Construct Subcontractor Details ==========
  const creditorDetails = {
    '[subcontractorName]':
      previewDetail?.subcontractorAccount?.CompanyName ??
      previewDetail?.subcontractorAccount?.DebtorName ??
      previewDetail?.subcontractor?.name ??
      '',

    '[subcontractorAddress]': `${previewDetail?.subcontractor?.address
      ?.address ?? ''}<br />
    ${
      previewDetail?.subcontractor?.address?.country === 'Singapore'
        ? `${previewDetail?.subcontractor?.address?.country} ${previewDetail?.subcontractor?.address?.postCode}`
        : `${previewDetail?.subcontractor?.address?.postCode} ${previewDetail?.subcontractor?.address?.city}, ${previewDetail?.subcontractor?.address?.state}, ${previewDetail?.subcontractor?.address?.country}`
    }<br />`,

    '[subcontractorContactPerson]':
      previewDetail?.subcontractor?.contactPerson?.[0]?.name! ?? '',
    '[subcontractorContactNo]':
      previewDetail?.subcontractor?.contactPerson?.[0]?.contactNo! ?? '',
    '[subcontractorEmail]':
      previewDetail?.subcontractor?.contactPerson?.length > 0
        ? previewDetail?.subcontractor?.contactPerson[0]?.email!
        : '',
    '[subcontractorTinNo]': previewDetail?.subcontractor?.tinNo ?? '',
    '[subcontractorRegNo]': previewDetail?.subcontractor?.registrationNo ?? '',
    '[subcontractID]': previewDetail?.subcontract?.subcontractNo ?? '',
    '[subcontractTitle]': previewDetail?.subcontract?.title ?? '',
    '[creditTerm]': previewDetail?.subcontract?.creditTerm ?? '',

    // ========== Additional (Not Used) Fields ==========
    '[CreditorGSTRegNo]': previewDetail?.GSTRegNo! ?? '',
    '[CreditorCompanyRegNo]':
      previewDetail?.CreditorAccount?.CompanyRegNo! ?? '',
    '[CreditorBankAccName]': previewDetail?.CreditorAccount?.BankName! ?? '',
    '[CreditorBankAccNo]': previewDetail?.CreditorAccount?.BankAccountNo! ?? '',
    '[CreditorTIN]': previewDetail?.CreditorAccount?.einvoice_TIN! ?? '',
    '[CreditorSSTRegNo]': previewDetail?.SSTRegNo! ?? '',

    // ========== Document Metadata ==========
    '[docNo]': previewDetail?.docNo! ?? '',
    '[docDate]': formatDate(previewDetail?.docDate!) ?? '',
    '[docRef]': previewDetail?.docRef! ?? '',
    '[referenceNo]': previewDetail?.docRef! ?? '',
    '[uniqueIdentifierNo]': previewDetail?.eInvoiceIrbmUniqueID! ?? '',
    '[docAmt]': amtStr(previewDetail?.docAmt!),
    '[description]': previewDetail?.description! ?? '',

    // ========== QR Code ==========
    '[qrCode]':
      previewDetail?.isEInvoice && previewDetail?.eInvoiceQrUrl
        ? generateQRCodeSVG(previewDetail?.eInvoiceQrUrl)
        : '',

    // ==========================
    // BANK DETAILS
    // ==========================
    '[bankName]': previewDetail?.bankDetails?.name ?? '',
    '[bankAddress]': `${bankAddress?.address}, ${bankAddress?.city},
          ${bankAddress?.state}, ${bankAddress?.country}, ${bankAddress?.postCode}`,
    '[bankAccountNo]': previewDetail?.bankDetails?.acctNo ?? '',
    '[bankSwiftCode]': previewDetail?.bankAccount?.swiftCode ?? '',

    // ============================
    // Currency
    // ============================
    '[companyCurrency]':
      // previewDetail?.user?.companyCurrency! ?? companyDetails?.currency ?? '',
      (companyDetails?.currency && companyDetails?.currency == 'Ringgit'
        ? 'Malaysian Ringgit'
        : companyDetails?.currency) ?? '',
    '[companyCurrencyCode]':
      previewDetail?.user?.companyCurrencyCode! ??
      companyDetails?.currencyCode ??
      '',
    '[currency]': previewDetail?.currencyByDoc?.name ?? '',
    '[currencyCode]': previewDetail?.currencyByDoc?.code ?? '',
    '[currencyRate]': (previewDetail?.exchangeRate ?? 1.0).toFixed(8) ?? '',
    '[localDocAmt]': amtStr(previewDetail?.localDocAmt),

    '[approverNameL1]': approverNameL1,
    '[approvalDateL1]': approvalDateL1,
    '[roleNameL1]': roleNameL1,
    '[approverNameL2]': approverNameL2,
    '[approvalDateL2]': approvalDateL2,
    '[roleNameL2]': roleNameL2,
    '[approverNameL3]': approverNameL3,
    '[approvalDateL3]': approvalDateL3,
    '[roleNameL3]': roleNameL3,
    '[approverNameL4]': approverNameL4,
    '[approvalDateL4]': approvalDateL4,
    '[roleNameL4]': roleNameL4,
    '[approverNameL5]': approverNameL5,
    '[approvalDateL5]': approvalDateL5,
    '[roleNameL5]': roleNameL5,
  };

  // ========== Document Type Processing ==========
  switch (docType) {
    // =========================
    // PAYMENT
    // =========================
    case 'payment':
      return Object.assign(paramVal, creditorDetails, {
        // Header Information
        // '[description]': previewDetail?.description! ?? '',
        '[paymentDate]': previewDetail?.transactionDate! ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt ?? 0),
        // IAQ want to use itemDocDate for payment date
        '[itemDocDate]':
          previewDetail?.allocation?.length > 0
            ? formatDate(previewDetail?.allocation?.[0]?.docDate)
            : '',
        '[transactionStatus]': previewDetail?.receiptStatus,
        '[docDate]': formatDate(previewDetail?.docDate),
        '[bankCode]': previewDetail?.bankAccount?.code ?? '',
        '[payAmt]':
          amtStr(
            previewDetail?.allocation?.reduce((total, item) => {
              return total + parseFloat(item?.allocatedByDoc || 0);
            }, 0) ?? 0,
          ) ?? '',

        // Not Used Fields
        '[Remark]': previewDetail?.Remark! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',

        // Item Listing
        items: previewDetail?.allocation?.map((el, i) => ({
          '[Index]': ItemIndex ?? 0 + i + 1,
          '[itemDocDate]': el?.docDate ? formatDate(el?.docDate) : '',
          '[itemDocNo]': el?.docNo ?? '',
          '[AllocationRefNo]': el?.docRef ?? '',
          '[itemDescription]': el?.description ?? '',
          '[itemDocAmt]': amtStr(el?.docAmt ?? 0),
          '[accumAllocatedAmt]': amtStr(el?.allocatedAmt ?? 0),
          '[itemPayAmt]': amtStr(el?.allocatedByDoc ?? 0),
          '[AllocDefaultAmt]': amtStr(el?.docAmt ?? 0),
          '[itemAllocatedAmt]': amtStr(el?.allocatedByDoc ?? 0),

          // Not Used Sub Items
          subItem: el?.AllocatedDocs?.map((v, index) => ({
            '[SubItemIndex]': index + 1,
            '[AllocatedDetail]': `${v?.DebitDocNo!} ${formatDate(
              v?.DebitDocDate!,
            )} - ${v?.DebitDescription!}`,
            '[AllocatedDocAmt]': !!v?.AllocationAmt
              ? `(${amtStr(v?.AllocationAmt!)})`
              : 0,
          })),
        })),
        '[SumAllocationAmt]': amtStr(
          allpreviewDetail?.Allocation?.reduce(
            (a, b) => a + Number(b?.AllocationAmt!),
            0,
          ),
        ),
      });

    // =========================
    // ADVANCES
    // =========================
    case 'advances':
      return Object.assign(paramVal, creditorDetails, {
        // Header Information
        // '[description]': previewDetail?.description! ?? '',
        '[principalAmt]': previewDetail?.bankDocAmt! ?? '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt!),
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),

        // Not Used Fields
        '[Remark]': previewDetail?.Remark! ?? '',
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt!),
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
      });

    // =========================
    // REFUND
    // =========================
    case 'refund':
      return Object.assign(paramVal, creditorDetails, {
        // Header Information
        '[paymentFor]': previewDetail?.description! ?? '',
        '[docAmt]': amtStr(previewDetail?.docAmt!),
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),

        // Not Used Fields
        '[Remark]': previewDetail?.Remark! ?? '',
        '[RefundMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',

        // Not Used Allocation Items
        items: previewDetail?.Allocation?.map((el, i) => ({
          '[AllocationDocDate]': formatDate(
            el?.DebitDocDate! ?? el?.CreditDocDate!,
          ),
          '[AllocationDocNo]': el?.DebitDocNo! ?? el?.CreditDocNo! ?? '',
          '[AllocationRefNo]': el?.DebitRefNo! ?? el?.CreditRefNo! ?? '',
          '[AllocationRemark]': el?.Description! ?? '',
          '[AllocationAmt]': amtStr(el?.AllocationAmt!),
        })),
        '[SumAllocationAmt]': allpreviewDetail?.Allocation?.reduce(
          (a, b) => a + Number(b?.AllocationAmt),
          0,
        ).toFixed(2),
      });

    // =========================
    // INVOICE
    // =========================
    case 'invoice':
      return Object.assign(paramVal, creditorDetails, {
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
        '[taxAmt]': amtStr(previewDetail?.taxAmt!),
        '[taxRate]': (previewDetail?.taxRate ?? 0) + '%',
        '[principalAmt]': amtStr(
          previewDetail?.docAmt - previewDetail?.taxAmt!,
        ),
        items: previewDetail?.invoiceToSubconItem?.map((item, i) => ({
          '[index]': i + 1,
          '[itemName]': item?.costItem?.name! ?? '',
          '[itemDescription]': item?.remarks! ?? '',
          '[itemTotalAmt]': amtStr(item?.docAmt!),
          '[itemBaseAmt]': amtStr(item?.docAmt - item?.taxAmt || 0),
          '[itemPrincipalAmt]': amtStr(item?.docAmt - item?.taxAmt!),
        })),

        // Not Used Fields
        '[Remark]': previewDetail?.Remark! ?? '',
      });

    // =========================
    // CREDIT NOTE
    // =========================
    case 'credit-note':
      return Object.assign(paramVal, creditorDetails, {
        '[itemDescription]': previewDetail?.description! ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
        '[principalAmt]': amtStr(
          previewDetail?.docAmt - previewDetail?.taxAmt!,
        ),
        '[taxAmt]': amtStr(previewDetail?.taxAmt!),
        // CX-5605: items often carry no remarks - fall back to the item name,
        // which is what [itemDescription] means in every other module
        items: previewDetail?.CNtoSubconItem?.map((item, i) => ({
          '[index]': i + 1,
          '[itemName]':
            item?.costItem?.name ?? item?.revenueCategory?.name ?? '',
          '[itemDescription]':
            item?.remarks ||
            item?.costItem?.name ||
            item?.revenueCategory?.name ||
            '',
          '[taxRate]': item?.taxRate! + '%',
          '[itemPrincipalAmt]': amtStr(item?.docAmt - item?.taxAmt!),
          '[itemTaxAmt]': amtStr(item?.taxAmt!),
          '[itemTotalAmt]': amtStr(item?.docAmt!),
          '[itemBaseAmt]': amtStr(item?.docAmt - item?.taxAmt || 0),
        })),

        // Not Used Allocation Section
        '[Remark]': previewDetail?.Remark! ?? '',
        allocItems: previewDetail?.Allocation?.map((el, i) => ({
          '[AllocIndex]': i + 1,
          '[AllocDocDate]': formatDate(el?.CreditDocDate!),
          '[AllocDocNo]': el?.CreditDocNo!,
          '[AllocDesc]': el?.Description!,
          '[AllocAmt]': amtStr(el?.AllocationAmt!),
        })),
        '[SumBaseAmt]': allpreviewDetail?.APCreditNoteItem?.reduce(
          (a, b) => a + Number(b?.Amount),
          0,
        ).toFixed(2),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.APCreditNoteItem?.reduce(
            (a, b) => a + Number(b?.TaxAmt),
            0,
          ).toFixed(2),
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.APCreditNoteItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0,
          ).toFixed(2),
        ),
      });

    // =========================
    // DEBIT NOTE
    // =========================
    case 'debit-note':
      return Object.assign(paramVal, creditorDetails, {
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
        '[principalAmt]': amtStr(
          previewDetail?.docAmt - previewDetail?.taxAmt!,
        ),
        '[taxAmt]': amtStr(previewDetail?.taxAmt!),
        // CX-5605: claim-cancellation DNs have no DNtoSubconItem rows, so
        // synthesize a single item row from the header instead of printing blank
        items: previewDetail?.DNtoSubconItem?.length
          ? previewDetail?.DNtoSubconItem?.map((item, i) => ({
              '[index]': i + 1,
              '[itemName]':
                item?.costItem?.name ?? item?.revenueCategory?.name ?? '',
              '[itemDescription]':
                item?.remarks ||
                item?.costItem?.name ||
                item?.revenueCategory?.name ||
                '',
              '[taxRate]': item?.taxRate! + '%',
              '[itemPrincipalAmt]': amtStr(item?.docAmt - item?.taxAmt!),
              '[itemTaxAmt]': amtStr(item?.taxAmt!),
              '[itemTotalAmt]': amtStr(item?.docAmt!),
              '[itemBaseAmt]': amtStr(item?.docAmt - item?.taxAmt || 0),
            }))
          : [
              {
                '[index]': 1,
                '[itemDescription]': previewDetail?.description ?? '',
                '[itemPrincipalAmt]': amtStr(
                  previewDetail?.docAmt - previewDetail?.taxAmt,
                ),
                '[itemTaxAmt]': amtStr(previewDetail?.taxAmt),
                '[itemTotalAmt]': amtStr(previewDetail?.docAmt),
                '[itemBaseAmt]': amtStr(
                  previewDetail?.docAmt - previewDetail?.taxAmt || 0,
                ),
                '[taxRate]': previewDetail?.taxRate + '%',
              },
            ],

        // Not Used Fields
        '[Remark]': previewDetail?.Remark! ?? '',
        '[SumBaseAmt]': allpreviewDetail?.APDebitNoteItem?.reduce(
          (a, b) => a + Number(b?.Amount),
          0,
        ).toFixed(2),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.APDebitNoteItem?.reduce(
            (a, b) => a + Number(b?.TaxAmt),
            0,
          ).toFixed(2),
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.APDebitNoteItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0,
          ).toFixed(2),
        ),
      });

    // =========================
    // RETENTION CLAIMS
    // =========================
    case 'retention-claims':
      return Object.assign(paramVal, creditorDetails, {
        // Claim Details
        // '[description]': previewDetail?.description! ?? '',
        '[startDate]': formatDate(previewDetail?.docDate! ?? ''),
        '[endDate]': formatDate(previewDetail?.docDueDate! ?? ''),
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
        '[voDisplayAmt]': amtStr(
          previewDetail?.subcontract?.subcontractVOSum ?? '',
        ),
        '[maxRetentionSum]': amtStr(
          previewDetail?.subcontract?.maxRetentionSum ?? '',
        ),
        '[maxRetentionPerc]': amtStr(
          previewDetail?.subcontract?.maxRetentionPerc ?? '',
        ),
        '[balanceAdvanceAmt]': amtStr(
          previewDetail?.balanceAdvanceAmt?.toString() ?? '0',
        ),
        '[maxAdvanceAmt]': amtStr(
          previewDetail?.subcontract?.maxAdvanceAmt ?? '',
        ),
        '[submittedRetentionAmt]': amtStr(
          previewDetail?.submittedRetentionAmt ?? '',
        ),
        '[retentionAmt]': amtStr(previewDetail?.retentionAmt ?? ''),
        '[currentAdvRecoupmentAmt]': amtStr(
          previewDetail?.currentAdvRecoupmentAmt ?? '',
        ),
        '[previousAdvRecoupedAmt]': amtStr(
          previewDetail?.previousAdvRecoupedAmt?.toString() ?? '0',
        ),
        '[totalAdvRecoupedAmt]': amtStr(
          (
            Number(previewDetail?.previousAdvRecoupedAmt || 0) +
            Number(previewDetail?.currentAdvRecoupmentAmt || 0)
          ).toString(),
        ),
        '[nettAdvRecoupedAmt]': amtStr(
          (
            Number(previewDetail?.maxAdvanceAmt || 0) -
            (Number(previewDetail?.previousAdvRecoupedAmt || 0) +
              Number(previewDetail?.currentAdvRecoupmentAmt || 0))
          ).toString(),
        ),
        '[previousRetentionAmt]': amtStr(
          previewDetail?.previousRetentionAmt?.toString() ?? '0',
        ),
        '[totalRetentionAmt]': amtStr(
          (
            Number(previewDetail?.previousRetentionAmt || 0) +
            Number(previewDetail?.retentionAmt || 0)
          ).toString(),
        ),
        '[nettRetentionAmt]': amtStr(
          (
            Number(previewDetail?.subcontract?.maxRetentionSum || 0) -
            (Number(previewDetail?.previousRetentionAmt || 0) +
              Number(previewDetail?.retentionAmt || 0))
          ).toString(),
        ),
        '[invoiceNo]': previewDetail?.docNo! ?? '',
        '[approvalDate]': formatDate(previewDetail?.docDate! ?? ''),
        '[docDueDate]': formatDate(previewDetail?.submittedDate! ?? ''),
        '[claimDocNo]': previewDetail?.claimDocNo! ?? '',
        '[revisedContractSum]': amtStr(
          previewDetail?.subcontract?.revisedSubcontractSum ?? '',
        ),
        '[subcontractSum]': amtStr(
          previewDetail?.subcontract?.subcontractSum ?? '',
        ),
        '[taxRate]': (previewDetail?.taxRate ?? 0) + '%',
        '[taxAmt]': amtStr(previewDetail?.taxAmt ?? ''),
        '[companyCurrencyInWords]':
          previewDetail?.user?.companyCurrency! ??
          companyDetails?.currency ??
          '',
        '[docAmt]': amtStr(previewDetail?.docAmt!),
        '[releasedRetentionAmt]': amtStr(previewDetail?.baseAmt ?? 0),
        '[balanceRetentionAmt]': amtStr(
          (
            parseFloat(previewDetail?.baseAmt ?? '0') +
            parseFloat(previewDetail?.retention?.retentionSum ?? '0')
          ).toString(),
        ),
        '[totalRetentionToDateAmt]': amtStr(
          previewDetail?.currentCertifiedAmt ?? 0,
        ),
        '[releasedRetentionToDateAmt]': amtStr(
          previewDetail?.retention?.retentionSum ?? 0,
        ),
      });

    // =========================
    // CLAIM SUMMARY
    // =========================
    case 'claim-summary':
      const certifiedAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentCertifiedAmt
          : previewDetail?.submittedCertifiedAmt || '0',
      );
      const submittedVOAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentVOClaimAmt
          : previewDetail?.submittedVOClaimAmt || '0',
      );
      const previousCertifiedAmt = parseFloat(
        previewDetail?.previousCertifiedAmt || '0',
      );
      const previousVOAmt = parseFloat(
        previewDetail?.previousVOClaimAmt || '0',
      );
      const previousMosAmt = parseFloat(previewDetail?.previousMosAmt || '0');
      const submittedMosAmt = parseFloat(previewDetail?.submittedMosAmt || '0');
      const submittedDayworkAmt = parseFloat(
        previewDetail?.submittedDayWorkAmt || '0',
      );
      const retentionAmt = parseFloat(previewDetail?.retentionAmt || '0');

      const taxAmt = parseFloat(previewDetail?.taxAmt || '0');

      // CX-5105 reopen: cummulative = total claim approval + nett MOS - cummulative retention
      const cummSubTotal =
        parseFloat(previewDetail?.submittedCertifiedAmt ?? '0') +
        parseFloat(previewDetail?.submittedVOClaimAmt ?? '0') +
        parseFloat(previewDetail?.currentMosAmt ?? '0') -
        Number(previewDetail?.previousRetentionAmt || 0) -
        retentionAmt;

      return Object.assign(paramVal, creditorDetails, {
        // Claim Details
        // '[description]': previewDetail?.description! ?? '',
        '[startDate]': formatDate(previewDetail?.subcontract?.startDate! ?? ''),
        '[endDate]': formatDate(previewDetail?.subcontract?.endDate! ?? ''),
        '[totalAmtInWords]': moneyFunction(
          parseFloat(previewDetail?.submittedCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedVOClaimAmt ?? '0') +
            parseFloat(previewDetail?.currentMosAmt ?? '0') -
            parseFloat(previewDetail?.retentionAmt ?? '0') -
            parseFloat(previewDetail?.previousCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedDayWorkAmt ?? '0') +
            parseFloat(previewDetail?.taxAmt ?? '0') -
            Number(previewDetail?.currentAdvRecoupmentAmt || 0) -
            parseFloat(previewDetail?.submittedDeductionAmt ?? '0'),
        ),
        '[voDisplayAmt]': amtStr(
          previewDetail?.subcontract?.subcontractVOSum ?? '',
        ),
        '[maxRetentionSum]': amtStr(
          previewDetail?.subcontract?.maxRetentionSum ?? '',
        ),
        '[maxRetentionPerc]': amtStr(
          previewDetail?.subcontract?.maxRetentionPerc ?? '',
        ),
        '[submittedRetentionAmt]': amtStr(
          previewDetail?.submittedRetentionAmt ?? '',
        ),
        '[balanceAdvanceAmt]': amtStr(
          previewDetail?.balanceAdvanceAmt?.toString() ?? '0',
        ),
        '[maxAdvanceAmt]': amtStr(
          previewDetail?.maxAdvanceAmt?.toString() ?? '0',
        ),
        '[previousAdvRecoupedAmt]': amtStr(
          previewDetail?.previousAdvRecoupedAmt?.toString() ?? '0',
        ),
        '[totalAdvRecoupedAmt]': amtStr(
          (
            Number(previewDetail?.previousAdvRecoupedAmt || 0) +
            Number(previewDetail?.currentAdvRecoupmentAmt || 0)
          ).toString(),
        ),
        '[nettAdvRecoupedAmt]': amtStr(
          (
            Number(previewDetail?.maxAdvanceAmt || 0) -
            (Number(previewDetail?.previousAdvRecoupedAmt || 0) +
              Number(previewDetail?.currentAdvRecoupmentAmt || 0))
          ).toString(),
        ),
        '[previousRetentionAmt]': amtStr(
          previewDetail?.previousRetentionAmt?.toString() ?? '0',
        ),
        '[totalRetentionAmt]': amtStr(
          (
            Number(previewDetail?.previousRetentionAmt || 0) +
            Number(previewDetail?.retentionAmt || 0)
          ).toString(),
        ),
        '[nettRetentionAmt]': amtStr(
          (
            Number(previewDetail?.subcontract?.maxRetentionSum || 0) -
            (Number(previewDetail?.previousRetentionAmt || 0) +
              Number(previewDetail?.retentionAmt || 0))
          ).toString(),
        ),
        '[invoiceNo]': previewDetail?.docNo! ?? '',
        '[approvalDate]': formatDate(previewDetail?.docDate! ?? ''),
        '[docDueDate]': formatDate(previewDetail?.submittedDate! ?? ''),
        '[claimDocNo]': previewDetail?.claimDocNo! ?? '',
        '[revisedSubcontractSum]': amtStr(
          previewDetail?.subcontract?.revisedSubcontractSum ?? '',
        ),
        '[subcontractSum]': amtStr(
          previewDetail?.subcontract?.subcontractSum ?? '',
        ),
        '[taxRate]': (previewDetail?.taxRate ?? 0) + '%',
        '[taxAmt]': amtStr(previewDetail?.taxAmt ?? ''),
        '[companyCurrencyInWords]':
          previewDetail?.user?.companyCurrency! ??
          companyDetails?.currency ??
          '',
        '[docAmt]': amtStr(previewDetail?.docAmt!),

        // Current and Previous Amounts
        '[currentApprovalAmt]': amtStr(
          previewDetail?.submittedCertifiedAmt ?? '',
        ),
        '[currentVoClaimAmt]': amtStr(previewDetail?.submittedVOClaimAmt ?? ''),
        '[totalClaimApprovalAmt]': amtStr(
          (
            parseFloat(previewDetail?.submittedCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedVOClaimAmt ?? '0')
          ).toString(),
        ),
        '[currentMosAmt]': amtStr(previewDetail?.submittedMosAmt ?? ''),
        '[previousMosAmt]': amtStr(previewDetail?.previousMosAmt ?? ''),
        '[nettApprovalMosAmt]': amtStr(previewDetail?.currentMosAmt ?? ''),
        '[retentionAmt]': amtStr(previewDetail?.retentionAmt ?? ''),
        '[subtotal]': amtStr(
          (
            parseFloat(previewDetail?.submittedCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedVOClaimAmt ?? '0') +
            parseFloat(previewDetail?.submittedMosAmt ?? '0') -
            parseFloat(previewDetail?.previousMosAmt ?? '0') +
            parseFloat(previewDetail?.currentMosAmt ?? '0') -
            parseFloat(previewDetail?.retentionAmt ?? '0')
          ).toString(),
        ),
        '[previousCertifiedAmt]': amtStr(
          previewDetail?.previousCertifiedAmt ?? '',
        ),
        '[currentDayWorkAmt]': amtStr(previewDetail?.submittedDayWorkAmt ?? ''),
        '[amountDueForClaim]': amtStr(
          (
            parseFloat(previewDetail?.submittedCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedVOClaimAmt ?? '0') +
            parseFloat(previewDetail?.currentMosAmt ?? '0') -
            parseFloat(previewDetail?.retentionAmt ?? '0') -
            parseFloat(previewDetail?.previousCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedDayWorkAmt ?? '0')
          ).toString(),
        ),
        '[deduction]': amtStr(previewDetail?.submittedDeductionAmt ?? ''),
        '[currentAdvRecoupmentAmt]': amtStr(
          previewDetail?.currentAdvRecoupmentAmt ?? '',
        ),
        '[cummSubTotal]': amtStr(cummSubTotal),
        '[totalDocAmt]': amtStr(
          (
            parseFloat(previewDetail?.submittedCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedVOClaimAmt ?? '0') +
            parseFloat(previewDetail?.currentMosAmt ?? '0') -
            parseFloat(previewDetail?.retentionAmt ?? '0') -
            parseFloat(previewDetail?.previousCertifiedAmt ?? '0') +
            parseFloat(previewDetail?.submittedDayWorkAmt ?? '0') +
            parseFloat(previewDetail?.taxAmt ?? '0') -
            Number(previewDetail?.currentAdvRecoupmentAmt || 0) -
            parseFloat(previewDetail?.submittedDeductionAmt ?? '0')
          ).toString(),
        ),
      });

    // =========================
    // CLAIM WORKDONE
    // =========================
    case 'claim-workdone':
      return Object.assign(paramVal, creditorDetails, {
        // Claim Details
        // '[description]': previewDetail?.description! ?? '',
        '[startDate]': formatDate(previewDetail?.subcontract?.startDate! ?? ''),
        '[endDate]': formatDate(previewDetail?.subcontract?.endDate! ?? ''),
        '[totalAmtInWords]': moneyFunction(
          allpreviewDetail?.claimDetailCostWBS
            ?.reduce(
              (sum, item) => sum + Number(item?.claimWBS?.netCurrentAmt || 0),
              0,
            )
            .toFixed(2) || 0,
        ),

        '[voDisplayAmt]': amtStr(
          previewDetail?.subcontract?.subcontractVOSum ?? '',
        ),
        '[maxRetentionSum]': amtStr(
          previewDetail?.subcontract?.maxRetentionSum ?? '',
        ),
        '[maxRetentionPerc]': amtStr(
          previewDetail?.subcontract?.maxRetentionPerc ?? '',
        ),
        '[submittedRetentionAmt]': amtStr(
          previewDetail?.submittedRetentionAmt ?? '',
        ),
        '[balanceAdvanceAmt]': amtStr(
          previewDetail?.balanceAdvanceAmt?.toString() ?? '0',
        ),
        '[maxAdvanceAmt]': amtStr(
          previewDetail?.maxAdvanceAmt?.toString() ?? '0',
        ),
        '[previousAdvRecoupedAmt]': amtStr(
          previewDetail?.previousAdvRecoupedAmt?.toString() ?? '0',
        ),
        '[totalAdvRecoupedAmt]': amtStr(
          (
            Number(previewDetail?.previousAdvRecoupedAmt || 0) +
            Number(previewDetail?.currentAdvRecoupmentAmt || 0)
          ).toString(),
        ),
        '[nettAdvRecoupedAmt]': amtStr(
          (
            Number(previewDetail?.maxAdvanceAmt || 0) -
            (Number(previewDetail?.previousAdvRecoupedAmt || 0) +
              Number(previewDetail?.currentAdvRecoupmentAmt || 0))
          ).toString(),
        ),
        '[previousRetentionAmt]': amtStr(
          previewDetail?.previousRetentionAmt?.toString() ?? '0',
        ),
        '[totalRetentionAmt]': amtStr(
          (
            Number(previewDetail?.previousRetentionAmt || 0) +
            Number(previewDetail?.retentionAmt || 0)
          ).toString(),
        ),
        '[nettRetentionAmt]': amtStr(
          (
            Number(previewDetail?.subcontract?.maxRetentionSum || 0) -
            (Number(previewDetail?.previousRetentionAmt || 0) +
              Number(previewDetail?.retentionAmt || 0))
          ).toString(),
        ),
        '[invoiceNo]': previewDetail?.docNo! ?? '',
        '[approvalDate]': formatDate(previewDetail?.docDate! ?? ''),
        '[docDueDate]': formatDate(previewDetail?.submittedDate! ?? ''),
        '[claimDocNo]': previewDetail?.claimDocNo! ?? '',
        '[revisedSubcontractSum]': amtStr(
          previewDetail?.subcontract?.revisedSubcontractSum ?? '',
        ),
        '[subcontractSum]': amtStr(
          previewDetail?.subcontract?.subcontractSum ?? '',
        ),
        '[taxRate]': (previewDetail?.taxRate ?? 0) + '%',
        '[taxAmt]': amtStr(previewDetail?.taxAmt ?? ''),
        '[companyCurrencyInWords]':
          previewDetail?.user?.companyCurrency! ??
          companyDetails?.currency ??
          '',
        '[docAmt]': amtStr(previewDetail?.docAmt!),

        // Amounts for claim calculation
        '[currentApprovalAmt]': amtStr(
          previewDetail?.submittedCertifiedAmt ?? '',
        ),
        '[currentVoClaimAmt]': amtStr(previewDetail?.submittedVOClaimAmt ?? ''),
        '[totalClaimApprovalAmt]': amtStr(previewDetail?.grossAmt ?? ''),
        '[currentMosAmt]': amtStr(previewDetail?.submittedMosAmt ?? ''),
        '[previousMosAmt]': amtStr(previewDetail?.previousMosAmt ?? ''),
        '[nettApprovalMosAmt]': amtStr(previewDetail?.currentMosAmt ?? ''),
        '[retentionAmt]': amtStr(previewDetail?.retentionAmt ?? ''),
        '[subtotal]': amtStr(previewDetail?.baseAmt ?? ''),
        '[previousCertifiedAmt]': amtStr(
          previewDetail?.previousCertifiedAmt ?? '',
        ),
        '[currentDayWorkAmt]': amtStr(previewDetail?.submittedDayWorkAmt ?? ''),
        '[amountDueForClaim]': amtStr(
          previewDetail?.baseAmt -
            previewDetail?.submittedDayWorkAmt -
            previewDetail?.submittedDayWorkAmt!,
        ),
        '[deduction]': amtStr(previewDetail?.submittedDeductionAmt ?? ''),
        '[currentAdvRecoupmentAmt]': amtStr(
          previewDetail?.currentAdvRecoupmentAmt ?? '',
        ),
        '[totalDocAmt]': amtStr(previewDetail?.outstandingAmt ?? ''),

        // Sorting and Mapping items
        items: previewDetail?.claimDetailCostWBS
          ?.sort((a, b) => a?.sequence - b?.sequence) // Sorting items based on sequence
          ?.map((el, i) => ({
            '[index]': i + 1,
            '[itemDescription]': el?.name!,
            '[principalAmt]': amtStr(el?.claimWBS?.docAmt - el?.taxAmt!),
            '[awardedAmt]': amtStr(el?.claimWBS?.awardedAmt!),
            '[previousAmt]': amtStr(el?.claimWBS?.previousCertifiedAmt!),
            '[currentAmt]': amtStr(el?.claimWBS?.currentCertifiedAmt!),
            '[netAmt]': amtStr(el?.claimWBS?.netCurrentAmt!),
            '[awardedSubtotalAmt]': amtStr(el?.claimWBS?.awardedAmt || 0), // Subtotal for Awarded
            '[previousSubtotalAmt]': amtStr(
              el?.claimWBS?.previousCertifiedAmt || 0,
            ), // Subtotal for Previous
            '[currentSubtotalAmt]': amtStr(
              el?.claimWBS?.currentCertifiedAmt || 0,
            ), // Subtotal for Current
            '[netSubtotalAmt]': amtStr(el?.claimWBS?.netCurrentAmt || 0), // Subtotal for Net
          })),

        // Total amounts calculations
        '[awardedTotalAmt]': amtStr(
          allpreviewDetail?.claimDetailCostWBS
            ?.reduce(
              (sum, item) => sum + Number(item?.claimWBS?.awardedAmt || 0),
              0,
            )
            .toFixed(2),
        ),

        '[previousTotalAmt]': amtStr(
          allpreviewDetail?.claimDetailCostWBS
            ?.reduce(
              (sum, item) =>
                sum + Number(item?.claimWBS?.previousCertifiedAmt || 0),
              0,
            )
            .toFixed(2),
        ),

        '[currentTotalAmt]': amtStr(
          allpreviewDetail?.claimDetailCostWBS
            ?.reduce(
              (sum, item) =>
                sum + Number(item?.claimWBS?.currentCertifiedAmt || 0),
              0,
            )
            .toFixed(2),
        ),

        '[netTotalAmt]': amtStr(
          allpreviewDetail?.claimDetailCostWBS
            ?.reduce(
              (sum, item) => sum + Number(item?.claimWBS?.netCurrentAmt || 0),
              0,
            )
            .toFixed(2),
        ),
      });
  }
};
